import { FormattedMessage } from 'react-intl';
import * as styles from './MiniFooter.module.scss';
import Link from 'components/Link';

function MiniFooter() {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.rightsReserved}>
          <FormattedMessage
            defaultMessage="{year} AllTrails, LLC All Rights Reserved"
            values={{
              year: new Date().getFullYear()
            }}
          />
        </div>
        <div className={styles.links}>
          <Link href="/privacy" variant="secondary">
            <FormattedMessage defaultMessage="Privacy Policy" />
          </Link>
          |
          <Link href="/terms" variant="secondary">
            <FormattedMessage defaultMessage="Terms of Service" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MiniFooter;
